import "./styles.sass";
import React, { FC, useContext, useEffect, useState } from 'react'
import Input from '../../components/UI/input/GgInput';
import Button from '../../components/UI/button/GgButton';
import { showErrorToast, showSuccessToast } from '../../components/toasts';
import { Context } from '../..';
import users from "../users";

const Profile: FC<any> = () => {
  const [showButton, setShowButton] = useState<any>(false);
  const [updateUserPass, setUpdateUserPass] = useState<any>();
  const { roles, store, users } = useContext(Context);

  const [fetchUser, setFetchUser] = useState<any>()

  const handleUpdatePassword = async () => {
    const id = fetchUser._id
    console.log({ updateUserPass })
    await roles.updateUserPassword(id, updateUserPass).then(() => {
      setShowButton(false)
      setUpdateUserPass("")
    }).catch((err: any) => {
      showErrorToast(err)
    })
  }

  const handleSaveProfile = async () => {
    const id = fetchUser._id
    if (window.confirm("Are you sure you want to Update Your Profile !")) {
      await users.updateUserProfile(id, fetchUser)

    }
  }
  useEffect(() => {
    setFetchUser(store.user)
  }, [])

  return (
    <div className="user-edit" style={{ gridTemplateColumns: "none" }}>
      <header className="section">
        <div className="title-container">
          <div className="title"> User Profile</div>
          <div style={{ width: "10%" }}>
            <Button
              label="Save"
              className=""
              type="button"
              style={{
                width: "100%",
              }}
              onPress={() => {
                handleSaveProfile && handleSaveProfile()

              }} />
          </div>
        </div>
        <div id="calc-details" className="calc-details">
          <Input
            type="text"
            label="Name"
            value={fetchUser?.name}
            placeholder="Name"
            required={true}
            onChange={(vl) => setFetchUser({ ...fetchUser, name: vl })}
          />
          <Input
            type="text"
            label="Email"
            value={fetchUser?.email}
            placeholder="Email"
            required={true}
            onChange={(vl) => setFetchUser({ ...fetchUser, email: vl })}
          />
          {/* TODO: Change Password Feature */}
          {/* TODO: Start */}
          {!showButton ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "1rem" }}>
              <Button
                label="Chnage Password"
                type="submit"
                style={{ width: "20%" }}
                onPress={() => { setShowButton(true) }}
              />
            </div>
          ) : (
            <div>
              <div style={{ display: "flex" }}>
                <Input
                  type="text"
                  label="Old Password"
                  style={{ width: "90%" }}
                  value={updateUserPass?.oldPassword}
                  placeholder="Old Password"
                  required={true}
                  onChange={(vl) => setUpdateUserPass({ ...updateUserPass, oldPassword: vl })}
                />
                <Input
                  type="text"
                  label="New Password"
                  style={{ width: "90%" }}
                  value={updateUserPass?.newPassword}
                  placeholder="New Password"
                  required={true}
                  onChange={(vl) => setUpdateUserPass({ ...updateUserPass, newPassword: vl })}
                />
                <Input
                  type="text"
                  label="Confirm New Password"
                  style={{ width: "90%" }}
                  value={updateUserPass?.confirmPassword}
                  placeholder="Confirm Password"
                  required={true}
                  onChange={(vl) => setUpdateUserPass({ ...updateUserPass, confirmPassword: vl })}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "center", padding: "1rem" }}>
                <Button
                  label="Save"
                  type="submit"
                  style={{ width: "20%" }}
                  onPress={() => { handleUpdatePassword() }}
                />
              </div>
            </div>
          )}
          {/* TODO: END */}
          <div className="title">Role</div>
          <div className="roleDisplay">
            <li className="rolefetch">
              {fetchUser?.role?.map((parrentRole: any, index: number) => {
                return (
                  <div className="">
                    <div style={{ display: "flex", fontWeight: "800", marginBottom: "0.5rem" }}>
                      <div className="name" style={{ fontWeight: "bold" }}>{parrentRole.title}</div>
                    </div>
                    <div style={{
                      marginLeft: "1rem",
                      display: 'flex',
                      gap: '5px',
                      flexDirection: 'column'
                    }}>
                      {parrentRole && parrentRole.children ? (
                        parrentRole.children.map((itemChild: any, index: number) => (
                          <>
                            <div key={index} style={{ display: "flex", padding: "0.3rem", flexDirection: "column" }}>
                              <div className="name" style={{ fontSize: "14px", fontWeight: "600" }}>{itemChild.title}</div>
                            </div>
                            {(itemChild?.add || itemChild?.edit || itemChild?.delete) && <div style={{ display: "flex", gap: 10, }}>
                              {
                                itemChild?.add && <div style={{
                                  fontSize: "12px",
                                  border: "1px #c1c1c1 solid",
                                  borderRadius: "1rem",
                                  padding: "3px 9px",
                                  color: "#000"
                                }} >ADD</div>
                              }
                              {
                                itemChild?.edit && <div style={{
                                  fontSize: "12px",
                                  border: "1px #c1c1c1 solid",
                                  borderRadius: "1rem",
                                  padding: "3px 9px",
                                  color: "#000"
                                }}>EDIT</div>
                              }{
                                itemChild?.delete && <div style={{
                                  fontSize: "12px",
                                  border: "1px #c1c1c1 solid",
                                  borderRadius: "1rem",
                                  padding: "3px 9px",
                                  color: "#000"
                                }}>DELETE</div>
                              }
                            </div>}
                          </>
                        ))
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )
              })}
            </li>
          </div>
        </div>
      </header>
    </div>

  )
}

export default Profile